import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { UserProvider } from "presentation/store/User/UserProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import UserComp from "presentation/view/section/UserGroup/User/UserComp";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const UserContMain = () => {
    return <ANAInfoWrapper permission={Permission.USER}>
        <MessageBarWrapper>
            <UserProvider>
                <GridStyles/>
                <UserComp/>
            </UserProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default UserContMain;